export const SERVICE_IDS = {
  SMS: 1,
  IVR: 2,
  WHATSAPP: 3,
  MAILING: 4,
  CHAT: 5
}

export const CAMPAIGN_SERVICE_IDS = [
  SERVICE_IDS.SMS,
  SERVICE_IDS.IVR,
  SERVICE_IDS.WHATSAPP,
  SERVICE_IDS.MAILING
]

export const MENU_SECTION_IDS = {
  DASHBOARD: 'dashboard',
  CAMPAIGNS: 'campaigns',
  CUSTOMER_CARE: 'customer_care',
  TOOLS: 'tools',
  CHAT: 'chat',
  SETTINGS: 'settings',
  CHANNELS: 'channels',
  SUPPORT: 'support',
  DOCUMENTATION: 'documentation',
  OTHERS: 'others'
}

export const TOOL_ITEM_IDS = {
  FILES: 'files',
  SHORT_URL: 'short_url',
  AGENDAS: 'agendas',
  BLACKLIST: 'blacklist'
}
